document.addEventListener('DOMContentLoaded', function () {
	const addressInputs = document.querySelectorAll('.google-address');

	if (!addressInputs.length) {
		return;
	}

	addressInputs.forEach(input => {
		const autocomplete = new window.google.maps.places.Autocomplete(input, {
			types: ['geocode', 'establishment'],  // You can adjust the types depending on your needs
			componentRestrictions: {country: "au"}  // Optionally restrict to a country
		});

		autocomplete.addListener('place_changed', function () {
			const place = autocomplete.getPlace();
			if (!place.geometry) {
				return;
			}

			// Initialize variables to store the address components
			let streetAddress = '';
			let city = '';
			let state = '';
			let postcode = '';

			// Extract address components
			place.address_components.forEach(component => {
				const types = component.types;

				if (types.includes('street_number')) {
					streetAddress = component.long_name + ' ' + streetAddress;
				}
				if (types.includes('route')) {
					streetAddress += component.long_name;
				}
				if (types.includes('locality')) {
					city = component.long_name;
				}
				if (types.includes('administrative_area_level_1')) {
					state = component.short_name;
				}
				if (types.includes('postal_code')) {
					postcode = component.long_name;
				}
			});

			// Set the google-address input value to the street address
			input.value = streetAddress;

			// Safeguard against missing data-sp-address attributes
			const closestAddressElement = input.closest('[data-sp-address]');

			if (!closestAddressElement) {
				return;  // Safely exit if no matching ancestor with data-sp-address is found
			}

			// Get the first part of the data-sp-address attribute to target the correct set
			const addressSetPrefix = closestAddressElement.getAttribute('data-sp-address').split('-')[0];

			// Find and populate corresponding address fields in the same set
			const addressSet = document.querySelectorAll(`[data-sp-address^="${addressSetPrefix}"]`);

			addressSet.forEach(element => {
				const addressType = element.getAttribute('data-sp-address').split('-')[1];

				if (addressType === 'street') {
					element.querySelector('input').value = streetAddress;
				}
				if (addressType === 'city') {
					element.querySelector('input').value = city;
				}
				if (addressType === 'state') {
					element.querySelector('select').value = state;
				}
				if (addressType === 'postcode') {
					element.querySelector('input').value = postcode;
				}
			});

		});
	});
});
